export const uploadInChunks = async (file, chunkSize = 20 * 1024 * 1024, onProgressUpdate) => {
  const totalChunks = Math.ceil(file.size / chunkSize);
  const fileId = crypto.randomUUID();

  let lastResponse = null;

  for (let i = 0; i < totalChunks; i++) {
    const chunk = file.slice(i * chunkSize, (i + 1) * chunkSize);

    const formData = new FormData();
    formData.append('chunk', chunk);
    formData.append('fileId', fileId);
    formData.append('chunkIndex', i.toString());
    formData.append('totalChunks', totalChunks.toString());
    formData.append('fileName', file.name);

    const res = await fetch(`${process.env.REACT_APP_BACKEND_API}/chunk-upload`, {
      method: 'POST',
      body: formData,
    });
    console.log(`Uploaded chunk ${i + 1}/${totalChunks} for file ${file.name}`);
    console.log('Server response:', res);
    if (onProgressUpdate) {
      onProgressUpdate(i + 1, totalChunks);
    }
    lastResponse = await res.json(); // parse response only after the last one
  }

  console.log('✅ All chunks uploaded!');

  // If the last response contains the filePath, return it
  if (lastResponse?.filePath) {
    return {
      success: true,
      filePath: lastResponse.filePath,
    };
  }

  // Otherwise, fallback response
  return {
    success: true,
    fileId,
    totalChunks,
    note: 'No filePath returned from server',
  };
};
